import annualPlanner1 from '../../../shared/images/annual-planner-1.png';
import annualPlanner2 from '../../../shared/images/annual-planner-2.png';
import annualPlanner3 from '../../../shared/images/annual-planner-3.png';
import annualPlanner4 from '../../../shared/images/annual-planner-4.png';
import annualPlanner5 from '../../../shared/images/annual-planner-5.png';

/**
 * Content for the Planner Examples modal
 * Used with OnboardingModal component
 */
const plannerExamplesContent = [
  {
    image: annualPlanner1,
    title: 'The Planner',
    description:
      "Plan, Prepare, Record. The Planner allows you to design the training map for your team or individual clients. You can share, mark up, and Record Notes on a continuous timeline of someone's training.",
    gradientType: 'primary',
  },
  {
    image: annualPlanner2,
    title: 'Team Example – Plan Mode',
    description:
      "Here's a soccer team's plan for the upcoming off-season and competitive year. The plan makes clear the intentions and shows how the team will achieve a goal. Light-weight titles on the Plan blocks and descriptive notes in the Record Notes mode enable collaboration with the sport coach on when to schedule tough sessions.",
    gradientType: 'primary',
  },
  {
    image: annualPlanner3,
    title: 'Team Example – Record Notes Mode',
    description:
      'Sometimes plans don\'t pan out. Planner has your back. Simply label areas where the plan went off course, and apply a note to refer back to when those tough conversations come up.',
    gradientType: 'primary',
  },
  {
    image: annualPlanner4,
    title: 'Personal Training Example – Plan Mode',
    description:
      "This plan is for an individual client training for their first running event. They have signed up for 3 months of training. The practitioner has set forth a path to begin based on their goal and current ability. The plan provides key points of understanding that the practitioner has the client's best interest in mind and a proper plan that can be agreed upon.",
    gradientType: 'primary',
  },
  {
    image: annualPlanner5,
    title: 'Personal Training Example – Record Notes Mode',
    description:
      'After making notes in Record Notes mode, use the Export button to share with the client. This creates buy-in with a view of the plan that includes all necessary context. Use the notes to share ideas, set expectations, and establish the right mindset.',
    gradientType: 'primary',
  },
];

export default plannerExamplesContent;
